import { useEditorState } from 'platejs/react';

import { ToolbarButton } from './ToolbarButton';

export const ToolbarMarkButton = ({
  icon: Icon,
  label,
  type,
  clear,
}: {
  icon: React.ComponentType;
  label: string;
  type: string;
  clear?: string | string[];
}) => {
  const editor = useEditorState();

  return (
    <ToolbarButton
      active={!!editor?.selection && editor.api.hasMark(type)}
      tooltip={label}
      onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
        e.preventDefault();
        e.stopPropagation();

        if (clear) {
          const keys = Array.isArray(clear) ? clear : [clear];
          keys.forEach((key) => {
            if (editor.api.hasMark(key)) {
              editor.tf.removeMark(key);
            }
          });
        }

        editor.tf.toggleMark(type);
        editor.tf.focus();
      }}
    >
      <Icon />
    </ToolbarButton>
  );
};
